import { QueryResult, useQuery, OperationVariables } from '@apollo/client';
import GET_TOUR from 'graph/queries/tours/get-tour';
import { StoreTypename, Tour } from 'types';

export type TourStoreState = {
  tour?: Tour;
};

export type TourStoreDispatch = {
  tourRefetch: any;
};

export type TourStore = [TourStoreState, TourStoreDispatch];

export const getDefaultTourStoreState = (): any => ({
  __typename: StoreTypename.TOUR,
});

const useTourStore = (tourName: string): TourStore => {
  const { data, refetch: tourRefetch }: QueryResult<{ tour: Tour }> = useQuery(GET_TOUR, {
    variables: { where: { appId: 16, name: tourName } } as OperationVariables,
  });

  return [
    {
      ...(data && { tour: data.tour }),
    },
    {
      tourRefetch,
    },
  ];
};

export default useTourStore;
